import { render, staticRenderFns } from "./ApplicationPsychometrics.vue?vue&type=template&id=6d3361b2&"
import script from "./ApplicationPsychometrics.vue?vue&type=script&lang=js&"
export * from "./ApplicationPsychometrics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports